import React from "react";

import { Skeleton } from "@replo/design-system/components/skeleton/Skeleton";

export const SharePopoverSkeleton = () => {
  return (
    <div className="flex flex-col gap-4">
      <div>
        <Skeleton className="h-7 w-48 mb-2" />
        <Skeleton className="h-4 w-full" />
      </div>

      <div>
        <Skeleton className="h-4 w-20 mb-2" />
        <div className="flex gap-2">
          <Skeleton className="h-8 flex-1 rounded-lg" />
          <Skeleton className="h-8 w-8 rounded-lg" />
        </div>
      </div>

      <div className="pb-4 border-b border-border">
        <Skeleton className="h-4 w-28 mb-2" />
        <Skeleton className="h-8 w-full rounded-lg" />
      </div>

      <div className="flex flex-col gap-2">
        <div className="text-xs">
          <Skeleton className="h-5 w-32 mb-1" />
          <Skeleton className="h-4 w-40" />
        </div>
        <Skeleton className="aspect-video rounded-lg" />
      </div>
    </div>
  );
};
